import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import EditAccountsViewPage, { getDefaultPageUI } from "components/pages/EditAccountsViewPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureMabiAccountsEditAccountsView(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    //.update([ "paymentsWidgeteBills", "isActive"], true)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <EditAccountsViewPage ui={ ui } />
}